import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UserManagementPage from './pages/UserManagementPage';
import WarehouseManagementPage from './pages/WarehouseManagementPage';
import WarehousePage from './pages/WarehousePage';
import { useAuth } from './context/AuthContext';
import MaterialReceiptPage from './pages/MaterialReceiptPage';
import CompanySetupPage from './pages/CompanySetupPage';
import MaterialDeliveryPage from './pages/MaterialDeliveryPage';
import CustomersPage from './pages/CustomersPage';

const PrivateRoute = ({ element, requiredRoles = [] }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute element={<DashboardPage />} />
            }
          />
          <Route
            path="/user-management"
            element={
              <PrivateRoute 
                element={<UserManagementPage />}
                requiredRoles={['admin']}
              />
            }
          />
          <Route
            path="/warehouse-management"
            element={
              <PrivateRoute 
                element={<WarehouseManagementPage />}
                requiredRoles={['admin']}
              />
            }
          />
          <Route
            path="/warehouse"
            element={
              <PrivateRoute element={<WarehousePage />} />
            }
          />
          <Route
            path="/material-receipt"
            element={
              <PrivateRoute 
                element={<MaterialReceiptPage />}
                requiredRoles={['admin', 'officeAdmin', 'warehouseAdmin']}
              />
            }
          />
          <Route
            path="/material-delivery"
            element={
              <PrivateRoute 
                element={<MaterialDeliveryPage />}
                requiredRoles={['admin', 'officeAdmin', 'warehouseAdmin']}
              />
            }
          />
          <Route
            path="/company-setup"
            element={
              <PrivateRoute 
                element={<CompanySetupPage />}
                requiredRoles={['admin']}
              />
            }
          />
           <Route
            path="/customers"  // Add this route
            element={
              <PrivateRoute 
                element={<CustomersPage />}
                requiredRoles={['admin', 'officeAdmin']}
              />
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;